export default __webpack_public_path__ + "static/media/npm-icon.5306e3b2.svg";